import download from 'downloadjs'

// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_LOCAL_LOADING = 'change_local_loading'
export const CHANGE_PAGE_LOADING = 'change_page_loading'
export const CHANGE_ONBOARDING = 'change_onboarding'
export const CHANGE_ERR = 'change_err'
export const CHANGE_SUCCESS = 'change_success'
export const CHANGE_UPLOAD = 'change_upload'
export const CHANGE_DOWNLOAD = 'change_download'
export const CHANGE_CITIES = 'change_cities'
export const CHANGE_COMPANIES = 'change_companies'
export const CHANGE_CATEGORIES = 'change_categories'
export const CHANGE_CLASSIFIERS = 'change_classifiers'

export function changeLocalLoading(status) {
  return {
    type: CHANGE_LOCAL_LOADING,
    payload: status
  }
}

export function changePageLoading(status) {
  return {
    type: CHANGE_PAGE_LOADING,
    payload: status
  }
}

export function changeOnboarding(onboarding) {
  return {
    type: CHANGE_ONBOARDING,
    payload: onboarding
  }
}

export function changeErr(message) {
  return {
    type: CHANGE_ERR,
    payload: message
  }
}

export function changeSuccess(message) {
  return {
    type: CHANGE_SUCCESS,
    payload: message
  }
}

export function changeUpload(spCaseId, progress, total, err) {
  return {
    type: CHANGE_UPLOAD,
    payload: { spCaseId, progress, total, err }
  }
}

export function changeDownload(spCaseId, fileRequest, fileId, progress, total, err) {
  return {
    type: CHANGE_DOWNLOAD,
    payload: { spCaseId, fileRequest, fileId, progress, total, err }
  }
}

export function changeCities(cities) {
  return {
    type: CHANGE_CITIES,
    payload: cities,
  }
}

export function changeCompanies(companies) {
  return {
    type: CHANGE_COMPANIES,
    payload: companies,
  }
}

export function changeCategories(categories) {
  return {
    type: CHANGE_CATEGORIES,
    payload: categories,
  }
}

export function fetchCities(uf) {
  return function (dispatch) {
    return serverAPI.get(`/util/cities/${uf}`)
      .then(response => {
        const cities = response.data.map((city, index) => {
          return {
            id: index,
            value: city
          }
        })

        dispatch(changeCities(cities))
      })
      .catch(_ => {})
  }
}

export function fetchCompanies() {
  return function (dispatch) {
    return serverAPI.get('/company')
      .then(response => {
        const companies = response.data
          // Prevent a bug in Select component
          .filter(company => {
            if (company.id && company.name) {
              return true
            }
            return false
          })
          .map((company, index) => {
            return {
              id: company.id,
              value: company.name,
            }
          })

        dispatch(changeCompanies(companies))
      })
      .catch(_ => {})
  }
}

export function fetchCategories(companyId) {
  return function (dispatch) {
    let url = `/company/category`
    if (companyId) {
      url = url + `/${companyId}`
    }
    return serverAPI.get(url)
      .then(response => {
        const categories = response.data.map((categories, index) => {
          return {
            id: categories.id,
            value: categories.descricao,
          }
        })

        dispatch(changeCategories(categories))
      })
      .catch(_ => {})
  }
}

export function downloadFile(spCaseId, fileRequest, fileId) {
  return function (dispatch) {
    let url = `/file/size/${fileRequest}/${spCaseId}`

    if (fileRequest === 'minuta' || fileRequest === 'protocolo' || fileRequest === 'drive') {
      url = url + `/${fileId}`
    }
    serverAPI.get(url)
      .then(response => {
        let config = {
          onDownloadProgress: e => {
            dispatch(changeDownload(spCaseId, fileRequest, fileId, e.loaded, response.data.size, false))
          },
        }

        url = `/file/download/${fileRequest}/${spCaseId}`

        if (fileRequest === 'minuta' || fileRequest === 'protocolo' || fileRequest === 'drive') {
          url = url + `/${fileId}`
        }

        return serverAPI.get(url, config)
          .then(response => {
            const { base64, real_name, type } = response.data
            let name = fileRequest + '_' + spCaseId + (type === 'application/zip;' ? '.zip' : '.pdf')

            if (fileRequest == 'drive') name = real_name

            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers)
            const file = new Blob([byteArray], { type })


            download(file, name, type)
          })
          .catch(_ => {})
      })
      .catch(_ => {})
  }
}
